import React from 'react';
import RoleListPage from '../RoleManagement/RoleListPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './ShopPage.module.css';

const ShopPage: React.FC = () => (
  <RoleListPage config={ROLE_CONFIGS.shop} styles={styles} />
);

export default ShopPage;
